/** Tagger generates HTML tags and handle the clicks from it using a bridge between javascript and java.
 * <p>
 * In the Messages widget class (all chat displayed to user), we tag \2$username\2 and \2@tablename\2
 * and make it clickable.
 *
 * @since 6.2.75
 * @author Maarten Spoek
 * @version 1.0
 */
/**
 * Actions a chat line can offer. The line carries the link text, the action and its
 * arguments; what the action does is decided by the client. An action only opens
 * something -- it never acts on its own.
 */
export enum TagAction {
    QSRegister = 'qsregister', // args: partner name, scoring method, activity id
}

/**
 * Separates label, action and arguments inside an action tag. Not \x03: that already
 * separates sections of a server command, and a link text may well contain a colon.
 */
export const TAG_ARG_SEPARATOR = '\x1f';

export default class Tagger {
    static createTableTag(name: string) {
        return "\x02@" + name + "\x02";
    }

    static createUserTag(name: string) {
        return "\x02$" + name + "\x02";
    }

    static createActionTag(label: string, action: TagAction, ...args: string[]) {
        return "\x02!" + [label, action as string, ...args].join(TAG_ARG_SEPARATOR) + "\x02";
    }
}